// TODO: refactor to use React ref()
export default function overflow(e) {
  const { target } = e;
  const orphanLimit = 2;

  const { contentRect } = e;
  const contentWidth = contentRect?.width || target.getBoundingClientRect().width;

  const list = Array.from(target.querySelectorAll('li'));
  const shim = target.parentNode.querySelector('.ui-code-explorer-overflow');

  let visibleTop = null;

  const collection = list.map((li, index) => {
    const { top, width } = li.getBoundingClientRect();
    const el = li.firstChild;
    const lang = el.dataset.id;
    const name = el.innerText;

    visibleTop = visibleTop === null ? top : visibleTop;
    const wrapped = top > visibleTop;
    const selected = li.classList.contains('selected');
    return { top, index, wrapped, width, selected, lang, name };
  });

  const wrapAll = collection.length - collection.filter(el => el.wrapped).length === 1;
  const wrapped = wrapAll ? collection : collection.filter(el => el.wrapped);
  const shimWidth = shim ? shim.getBoundingClientRect().width : 0;
  const collectionWidth = collection.reduce((a, c) => c.width + a, 0);
  const absoluteWidth = contentWidth + shimWidth;

  const button = wrapped.length && wrapped[0];
  const index = wrapped.length ? button.index : -1;
  const selected = wrapped.findIndex(o => o.selected);

  // Deactivate the overflow element
  if (wrapped.length < 3 && collectionWidth < absoluteWidth) {
    return { index: -1, items: null };
  }

  // Restrict number of orphaned items
  if (list.length - wrapped.length < orphanLimit) {
    return { index: 0, items: wrapped };
  }

  // If the overflow items include a selected element return that index
  const selectedIndex = selected + 1 ? wrapped[selected].index : index;
  return { index, selected: selectedIndex, items: wrapped };
}
